import { Button, ButtonProps } from '@mui/material';

interface CommonButtonProps extends ButtonProps {
  children: React.ReactNode;
}

export const CommonButton = ({ children, ...props }: CommonButtonProps) => {
  return (
    <Button
      variant="contained"
      {...props}
      sx={{ 
        whiteSpace: 'nowrap', 
        minWidth: 120, 
        color: '#fff', 
        backgroundColor: '#1b1b1b', 
        boxShadow: 'none', 
        fontWeight: 400, 
        '&:hover': { 
          boxShadow: 'none',
          backgroundColor: '#333'
        },
        transition: 'all 0.3s ease',
        ...props.sx
      }}
    >
      {children}
    </Button>
  );
}; 